<template>
  <div>
  <div class="container header">
    <div class="row justify-content-center align-items-center">
      <div class="text-center">
        <h2 class="text-white py-2">Modo Anfitrión</h2>
        </div>
      </div>
  </div>
  <div class="container">
    <div class="row text-center" v-if="sinMensajes">No hay mensajes</div>
    <div class="spinner-border" role="status" v-if="loading">
      <span class="sr-only">cargando...</span>
    </div>
    <div class="row">
      <div class="col-12 m-0 p-0">
        <div class="message-body" id="mensajes">
          <div
            class="row border rounded p-2 mb-2 message-text shadow"
            v-for="message in messages"
            :key="message.id"
            :v-if="message.pantalla"
          >
            <div class="col-sm-1 avatacol">
              <img src="../assets/img/chat/icono-user.png" class="useravatar">
            </div>
            <div class="col-sm-11">
            <strong class="mg-text text-capitalize">{{
              message.username
            }}</strong>
            <p class="message pt-1">{{ message.text }}</p>
<!--            <div class="fecha">-->
<!--              <small>{{ $moment(message.fecha).fromNow() }}</small>-->
<!--            </div>-->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import fire from "./../fire";

export default {
  name: "ListaChat",
  // eslint-disable-next-line vue/no-unused-components
  data() {
    return {
      messages: [],
      loading: true,
      sinMensajes: false
    };
  },
  methods: {},
  mounted() {
    let viewMessage = this;
    const itemsRef = fire
      .database()
      .ref("messages")
      .orderByChild("pantalla")
      .equalTo(true);
    console.log(itemsRef);
    itemsRef.on("value", snapshot => {
      let data = snapshot.val();
      let messages = [];
      if (data) {
        Object.keys(data).forEach(key => {
            messages.push({
              id: key,
              username: data[key].username,
              text: data[key].text,
              fecha: data[key].fecha
            });
          });
          viewMessage.messages = messages;
          this.$moment.locale("es");
        }else{
          viewMessage.sinMensajes = true;
          
        }
        this.loading = false;
      });
      
      
  }
};
</script>

<style lang="scss" scoped>
.header{
  background-color: #000;
  height: 50px;
  z-index: 10;
  max-width: 1250px;
  //width: 80vw;
  //margin-left: 10vw;
  //@media only screen and (max-width: 1400px) {
  //  width: 100vw;
  //  margin-left: 0;
  //}

  .row{
    margin: 0 !important;
    overflow-x: hidden !important;
  }
  .logozfold{
    height: 40px;
    width: auto;
    max-width: 100%;
    margin-top: -5px;
  }
  .packfolds{
    height: 55px;
    width: auto;
    max-width: 100%;
    margin-top: 5px;
  }
}

#mensajes {
  padding: 20px 0;
  @media only screen and (max-width: 480px) {
    padding: 70px 0;
  }
  display: flex;
  flex-direction: column-reverse;
  flex-wrap: nowrap;
  justify-content: flex-end;
  align-items: stretch;
  align-content: stretch;
  .avatacol {
    max-width: 50px;
  }
  .message-text {
    font-size: 1em;
    word-break: break-all;
    &:nth-child(even) {
      background: #f4f4f4;
    }
    &:hover {
      border-color: #007bff !important;
    }
    .fecha {
      font-style: italic;
    }
  }
  .useravatar{
    width: 30px;
  }
}
</style>
